export default __webpack_public_path__ + "static/media/screen11.0b9605c6.svg";